export default __webpack_public_path__ + "static/farm-e26d3c1afe788ed98382fd79532dfbc2.jpg";